import { render } from "./VInputRadio.vue?vue&type=template&id=3b03fbe0"
import script from "./VInputRadio.vue?vue&type=script&lang=js"
export * from "./VInputRadio.vue?vue&type=script&lang=js"

import exportComponent from "E:\\.work\\freelance\\pet\\RONF-maps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__